/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Leave_TitleInputs */



/**
* | output |
* | --- |
* | "The recording is still running" |
*
* @param {Meeting_Offline_Leave_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_leave_title = /** @type {((inputs?: Meeting_Offline_Leave_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Leave_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname loopt nog")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement est toujours en cours")
	return /** @type {LocalizedString} */ ("The recording is still running")
});